import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "bg_white m-20",
  style: {
    "margin-bottom": "70px"
  }
};
const _hoisted_2 = {
  class: "wrap text-black p-t-20 p-b-20 p-l-40 p-r-40"
};
const _hoisted_3 = {
  class: "basic_info"
};
const _hoisted_4 = {
  class: "others"
};
const _hoisted_5 = {
  class: "bg_white m-t-10 p-l-20 p-r-20 p-t-10 p-b-10 text-black footer",
  style: {
    "width": "100%"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_form = _resolveComponent("el-form");
  return _openBlock(), _createElementBlock("main", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form, {
    ref: "form",
    model: $data.form,
    rules: $data.rules,
    "label-width": "130px",
    class: "m-t-20",
    "label-position": "left"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_cache[31] || (_cache[31] = _createElementVNode("h3", null, "基础信息", -1)), _createVNode(_component_el_row, {
      gutter: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "编码",
          prop: "",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.id = $event),
            style: {
              "width": "60%"
            },
            placeholder: "编码自动生成",
            disabled: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "商标名称",
          prop: "brand_name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.brand_name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.brand_name = $event),
            style: {
              "width": "60%"
            },
            placeholder: "请输入商标名称"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      gutter: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "申请号",
          prop: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.apply_code,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.apply_code = $event),
            style: {
              "width": "60%"
            },
            placeholder: "请输入申请号"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "注册号",
          prop: "reg_code"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.reg_code,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.form.reg_code = $event),
            style: {
              "width": "60%"
            },
            placeholder: "请输入注册号"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      gutter: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "国家地区",
          prop: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.register_country,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.form.register_country = $event),
            style: {
              "width": "60%"
            },
            placeholder: "请输入国家地区"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "申请人地址",
          prop: "apply_addr"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.apply_addr,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.form.apply_addr = $event),
            style: {
              "width": "60%"
            },
            placeholder: "请输入申请人地址"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      gutter: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "商标状态",
          prop: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.brand_status,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.form.brand_status = $event),
            style: {
              "width": "60%"
            },
            placeholder: "请输入商标状态"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "原注册人",
          prop: "register_name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.register_name,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.form.register_name = $event),
            style: {
              "width": "60%"
            },
            placeholder: "请输入原注册人"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      gutter: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "申请人英文名称",
          prop: "apply_name_en"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.apply_name_en,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.form.apply_name_en = $event),
            style: {
              "width": "60%"
            },
            placeholder: "请输入申请人英文名称"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "申请人英文地址",
          prop: "apply_addr_en"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.apply_addr_en,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.form.apply_addr_en = $event),
            style: {
              "width": "60%"
            },
            placeholder: "请输入申请人英文地址"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      gutter: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "申请人",
          prop: "apply_name",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.apply_name,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.form.apply_name = $event),
            style: {
              "width": "60%"
            },
            placeholder: "请输入申请人",
            disabled: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "代理机构",
          prop: "agent_org"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.agent_org,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.form.agent_org = $event),
            style: {
              "width": "60%"
            },
            placeholder: "请输入代理机构"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      gutter: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "类别",
          prop: "cate"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.cate,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.form.cate = $event),
            style: {
              "width": "60%"
            },
            placeholder: "请输入类别"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "商标类型",
          prop: "brand_cate"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.brand_cate,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.form.brand_cate = $event),
            style: {
              "width": "60%"
            },
            placeholder: "请输入商标类型"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      gutter: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 16
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "核定商品/服务组别",
          prop: "serve_group"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            type: "textarea",
            rows: 6,
            modelValue: $data.form.serve_group,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.form.serve_group = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "商标图形",
          prop: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            ref: "upload",
            action: $options.api_upload_url,
            "list-type": "picture-card",
            name: "file",
            "with-credentials": true,
            "on-success": $options.handlePhotoSuccess,
            "on-preview": $options.handlePhotoPreview,
            limit: 1,
            "on-remove": $options.handlePhotoRemove,
            accept: ".jpg,.png",
            "on-exceed": $options.handleExceed,
            "file-list": $data.imgfileList
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              size: "small",
              type: "text"
            }, {
              default: _withCtx(() => _cache[26] || (_cache[26] = [_createElementVNode("i", {
                class: "el-icon-plus"
              }, null, -1)])),
              _: 1,
              __: [26]
            })]),
            _: 1
          }, 8, ["action", "on-success", "on-preview", "on-remove", "on-exceed", "file-list"]), _cache[27] || (_cache[27] = _createElementVNode("div", {
            class: "el-upload__tip f_12 l_height_25"
          }, "支持png、jpg格式, 上限1M", -1)), _createVNode(_component_el_dialog, {
            modelValue: $data.dialogVisible,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $data.dialogVisible = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_image, {
              width: "100%",
              src: $data.dialogImageUrl,
              alt: ""
            }, null, 8, ["src"])]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1,
          __: [27]
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 12
      }, {
        default: _withCtx(() => [_cache[30] || (_cache[30] = _createElementVNode("h3", null, "证书信息", -1)), _createVNode(_component_el_form_item, {
          label: "暂无证书信息",
          prop: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            class: "upload-demo",
            action: $options.api_upload_url,
            "with-credentials": true,
            "on-preview": _ctx.handlePreview,
            "on-remove": $options.handleRemove,
            "before-remove": _ctx.beforeRemove,
            "on-success": $options.handlezsSuccess,
            "before-upload": $options.fileUpload,
            accept: ".pdf, .jpg",
            "on-exceed": $options.handleExceed1,
            "file-list": $data.fileList
          }, {
            tip: _withCtx(() => _cache[29] || (_cache[29] = [_createElementVNode("div", {
              class: "el-upload__tip"
            }, " 支持PDF、JPG格式，限2M内 ", -1)])),
            default: _withCtx(() => [_createVNode(_component_el_button, {
              size: "small",
              type: "primary"
            }, {
              default: _withCtx(() => _cache[28] || (_cache[28] = [_createTextVNode("上传")])),
              _: 1,
              __: [28]
            })]),
            _: 1
          }, 8, ["action", "on-preview", "on-remove", "before-remove", "on-success", "before-upload", "on-exceed", "file-list"])]),
          _: 1
        })]),
        _: 1,
        __: [30]
      })]),
      _: 1
    })]), _createElementVNode("div", _hoisted_4, [_cache[32] || (_cache[32] = _createElementVNode("h3", null, "时间进度", -1)), _createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 6
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "申请时间",
          prop: "apply_time"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.apply_time,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $data.form.apply_time = $event),
            style: {
              "width": "90%"
            },
            placeholder: "请输入申请时间"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 6
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "公告时间",
          prop: "publish_time"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.publish_time,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => $data.form.publish_time = $event),
            style: {
              "width": "90%"
            },
            placeholder: "请输入公告时间"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 6
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "注册时间",
          prop: "register_name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.reg_time,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.form.reg_time = $event),
            style: {
              "width": "90%"
            },
            placeholder: "请输入注册时间"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 6
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "有效期",
          prop: "validity_time"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.validity_time,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => $data.form.validity_time = $event),
            style: {
              "width": "90%"
            },
            placeholder: "请输入有效期"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _cache[33] || (_cache[33] = _createElementVNode("h3", null, "费用信息", -1)), _createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "单价",
          prop: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.price,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $data.form.price = $event),
            style: {
              "width": "60%"
            },
            placeholder: "仅限数字，支持小数",
            onChange: $options.changePrice
          }, null, 8, ["modelValue", "onChange"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "数量",
          prop: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.num,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $data.form.num = $event),
            style: {
              "width": "60%"
            },
            placeholder: "仅限正整数",
            onChange: $options.changeNum
          }, null, 8, ["modelValue", "onChange"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "总计",
          prop: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.total_price,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => $data.form.total_price = $event),
            style: {
              "width": "60%"
            },
            placeholder: "自动计算",
            disabled: "true"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "商品项/核定商品/服务",
          "label-width": "150px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            type: "textarea",
            rows: 6,
            modelValue: $data.form.goods_serve,
            "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => $data.form.goods_serve = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "备注",
          "label-width": "150px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            type: "textarea",
            rows: 6,
            modelValue: $data.form.remark,
            "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => $data.form.remark = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })])]),
    _: 1
  }, 8, ["model", "rules"])])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
    type: "primary",
    class: "search_button",
    onClick: _cache[25] || (_cache[25] = $event => $options.submitClick('form'))
  }, {
    default: _withCtx(() => _cache[34] || (_cache[34] = [_createTextVNode("提交")])),
    _: 1,
    __: [34]
  })])]);
}